/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of content block
 * @export
 */
export const SurfaceContentBlockType = {
    HTML: 'HTML',
    PROMO: 'PROMO',
    TEXT_IMAGE: 'TEXT_IMAGE',
    REWARDS: 'REWARDS',
    PRODUCTS: 'PRODUCTS',
    COUNTDOWN: 'COUNTDOWN',
    SPONSORS: 'SPONSORS',
    LIVE_BRACKET: 'LIVE_BRACKET',
    STEPS: 'STEPS',
    PRIZES: 'PRIZES',
    FAQ: 'FAQ',
    LEADERBOARD: 'LEADERBOARD',
    CTA_BANNER: 'CTA_BANNER',
    VIDEO: 'VIDEO',
    RICH_TEXT: 'RICH_TEXT',
    DIVIDER: 'DIVIDER',
    PLAYABLE_AD: 'PLAYABLE_AD',
    BRAND_CHALLENGE: 'BRAND_CHALLENGE',
    QUEST_SPONSORSHIP: 'QUEST_SPONSORSHIP',
    GUILD_SPONSORSHIP: 'GUILD_SPONSORSHIP',
    COMPETITION: 'COMPETITION',
    QUEST: 'QUEST',
    STREAMING: 'STREAMING',
    NOTIFICATION_SIGNUP: 'NOTIFICATION_SIGNUP',
    POLL: 'POLL',
    IMAGE_GALLERY: 'IMAGE_GALLERY',
    STATS: 'STATS',
    SOCIAL_EMBED: 'SOCIAL_EMBED',
    CONTAINER: 'CONTAINER',
    COLUMNS: 'COLUMNS',
    SCROLL_NAV: 'SCROLL_NAV',
    STORE_LOCATOR: 'STORE_LOCATOR',
    MY_POSITION: 'MY_POSITION',
    ACHIEVEMENTS: 'ACHIEVEMENTS',
    ONBOARDING: 'ONBOARDING',
    EARNING: 'EARNING',
    CODE_ENTRY: 'CODE_ENTRY',
    GAMIFICATION: 'GAMIFICATION',
    LOOTBOX: 'LOOTBOX',
    STREAM_ZONE: 'STREAM_ZONE',
    CHALLENGE_ZONE: 'CHALLENGE_ZONE'
} as const;
export type SurfaceContentBlockType = typeof SurfaceContentBlockType[keyof typeof SurfaceContentBlockType];


export function instanceOfSurfaceContentBlockType(value: any): boolean {
    for (const key in SurfaceContentBlockType) {
        if (Object.prototype.hasOwnProperty.call(SurfaceContentBlockType, key)) {
            if (SurfaceContentBlockType[key as keyof typeof SurfaceContentBlockType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceContentBlockTypeFromJSON(json: any): SurfaceContentBlockType {
    return SurfaceContentBlockTypeFromJSONTyped(json, false);
}

export function SurfaceContentBlockTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceContentBlockType {
    return json as SurfaceContentBlockType;
}

export function SurfaceContentBlockTypeToJSON(value?: SurfaceContentBlockType | null): any {
    return value as any;
}

export function SurfaceContentBlockTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceContentBlockType {
    return value as SurfaceContentBlockType;
}

